__turbopack_context__.v({
  "RichTextBlock": "RichTextBlock-module__FsX04G__RichTextBlock",
  "RichTextBlock__inner": "RichTextBlock-module__FsX04G__RichTextBlock__inner",
});
